import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import LayoutInner from '../../../../layouts/main/components/layout-inner/layout-inner';
import CustomButton from '../../../../shared/components/buttons/custom-button/custom-button';
import { DocumentAddIcon } from '../../../../shared/icons/document-add-icon';
import AuthGuard from '../../../auth/components/auth-guard/auth-guard';
import { setActiveRequestId } from '../../../request/store/requests-slice';
import { openModal } from '../../../ui/store/ui-slice';
import { UserPermissionType } from '../../../user/models/user-permission-type';
import SignRequestsContent from '../../components/sign-requests-content/sign-requests-content';
import { signRequestAlertId, signRequestCreateModalId } from '../../constants/constants';
import {
  setActiveSignRequestId,
  setIsSignRequestPreviewOpen,
  setSelectedSignRequestIds,
} from '../../store/sign-requests-slice';

const SignRequests = (): JSX.Element => {
  const dispatch = useDispatch();
  const { t } = useTranslation(['sign-requests', 'common']);

  useEffect(() => {
    return () => {
      dispatch(setSelectedSignRequestIds([]));
      dispatch(setActiveRequestId(null));
      dispatch(setActiveSignRequestId(null));
      dispatch(setIsSignRequestPreviewOpen(false));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AuthGuard permission={UserPermissionType.ViewDocuments}>
      <Helmet>
        <title>{t('menu.signRequests', { ns: 'common' })}</title>
      </Helmet>
      <LayoutInner
        alertId={signRequestAlertId}
        headerActionButton={
          <CustomButton
            type="primaryLight"
            htmlType="button"
            onClick={() => dispatch(openModal(signRequestCreateModalId))}
            icon={<DocumentAddIcon />}
          >
            {t('signNewDocument')}
          </CustomButton>
        }
      >
        <SignRequestsContent />
      </LayoutInner>
    </AuthGuard>
  );
};

export default SignRequests;
